module.exports = __webpack_public_path__ + "static/media/add-debit-card.84bf6ab2.jpg";